export default __webpack_public_path__ + "static/media/TikTok_Icon_Black_Circle.1baa61a4.png";